export const STORES_URL = 'stores';
export const STORE_URL = 'store';
export const ORDER_URL = 'orders';
export const LAST_SUFFIX = 'last';
export const OPT_IN = 'optin';
export const ADJUSTMENT_URL_SUFFIX = 'adjustment/discounts';
export const GIFTCARD_URL_SUFFIX = 'billing/unnamed/gift-cards';
export const CHECK_STORES_URL = 'draft-order/stores';
export const CHECK_STORES_URL_V2 = 'draft-order/v2/stores';
export const DELIVERY_GROUP_SUFFIX = 'delivery/groups';
export const DELIVERY_OPTIONS = 'delivery-options';
export const PICKUP_SUFFIX = 'pickup';
export const DRAFT_ORDER = 'draft-order';
export const BASE_URL = 'accounts';
export const CONTACT = 'contact-methods';
export const BILLING = 'billing';
export const CREDIT_CARDS = 'credit-cards';
export const FINANCING = 'financing';
export const DISCOUNTS = 'discounts';
export const OPTIONS = 'options';
export const PAYPAL = 'paypal';
export const SERVICE_LEVELS_SUFFIX = 'service-levels';
export const MARKETING_SLOT_URL = 'j/dsc/free-shipping-content?id=pg40027100018';
export const APPLE_PAY = 'applepay';
export const SESSION = 'session';
export const CHARITY = 'charity';
export const CHARITY_CONTENT = 'content/pg40013300014/mobile/S1';
export const CHARITY_CONTENT_DESKTOP = 'content/pg40023700016/online/S1';
export const PAGE_ID_CONTENT_URL = 'content/@pageId@/mobile/S1';
export const PAGE_ID_CONTENT_DESKTOP_URL = 'content/@pageId@/online/S1';
export const STORE_CURBSIDE_CHECKIN_URL = 'stores/curbside-checkin';
export const CURBSIDE_PICKUP_ORDER_URL = 'pickup/orders';
export const MULTI_STORE = 'pickup/stores?storeId';
export const IRIS_CONTENT_AGGREGATOR_URL =
    '/content-aggregator/shared-components/zones/S1/s/@irisSearchTerm@?searchTerm=@irisSearchTerm@';
